import React from 'react';
import { Drawer, FormSetting } from '../../components';
import { useStyles } from '../../services/material-ui';

const EditConfig: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormSetting />
      </main>
    </div>
  );
};

export default EditConfig;
